
import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import AuthService from "../../services/authService";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

function ResponsiveAppBar({ isHomePage }) {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElAbout, setAnchorElAbout] = React.useState(null);

    const [isLoggedIn, setIsLoggedIn] = React.useState(
        AuthService.isUserLoggedIn()
    );

    React.useEffect(() => {
        setIsLoggedIn(AuthService.isUserLoggedIn());
    }, []);

    const handleOpenNavMenu = (event) =>
        setAnchorElNav(event.currentTarget);

    const handleCloseNavMenu = () =>
        setAnchorElNav(null);

    const navButtonStyle = {
        color: "#d8d0cc",
        fontWeight: 800,
        fontFamily: "'Poppins', sans-serif",
        textTransform: "uppercase",
        fontSize: "12px",
        letterSpacing: "1.2px",
        px: 2,
        py: 1.2,
        borderRadius: "5px",
        position: "relative",
        transition: "0.25s",
        overflow: "hidden",

        "&:after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: "50%",
            width: "0%",
            height: "2px",
            background:
                "linear-gradient(90deg,#a5220d,#ff5420,#ff9a4d)",
            transform: "translateX(-50%)",
            transition: ".25s",
            boxShadow: "0 0 10px rgba(255,75,25,.55)",
        },

        "&:hover": {
            background:
                "linear-gradient(180deg,rgba(255,70,15,.10),rgba(255,70,15,.025))",
            color: "#ff7845",
            transform: "translateY(-1px)",
        },

        "&:hover:after": {
            width: "65%",
        },
    };

    const dropdownItemStyle = {
        color: "#d8d0cc",
        borderRadius: "5px",
        transition: "0.2s",
        fontSize: "13px",
        fontWeight: 600,
        fontFamily: "'Poppins', sans-serif",
        minHeight: "40px",
        px: 1.5,

        "&:hover": {
            background:
                "linear-gradient(90deg,rgba(255,70,15,.14),rgba(255,70,15,.025))",
            color: "#ff7440",
            paddingLeft: "20px",
        },
    };

    return (
        <AppBar
            position={isHomePage ? "absolute" : "sticky"}
            elevation={0}
            sx={{
                background:
                    "linear-gradient(180deg,rgba(5,5,5,.97),rgba(15,7,5,.94))",

                backdropFilter: "blur(18px)",

                borderBottom:
                    "1px solid rgba(255,70,15,.20)",

                py: .7,

                zIndex: 9999,

                boxShadow:
                    "0 10px 40px rgba(0,0,0,.55)",

                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "2px",
                    background:
                        "linear-gradient(90deg,transparent,#731808,#c7350e,#ff5420,#ff9a4d,#ff5420,#c7350e,#731808,transparent)",
                    boxShadow:
                        "0 0 18px rgba(255,70,15,.65)",
                },

                "&:after": {
                    content: '""',
                    position: "absolute",
                    bottom: 0,
                    left: "10%",
                    right: "10%",
                    height: "1px",
                    background:
                        "linear-gradient(90deg,transparent,rgba(255,75,25,.25),transparent)",
                },
            }}
        >

            <Container maxWidth="xl">

                <Toolbar
                    disableGutters
                    sx={{
                        position: "relative",

                        minHeight: {
                            xs: 58,
                            md: 72,
                        },
                    }}
                >

                    {/* ================================================= */}
                    {/* DESKTOP LOGO - CENTER */}
                    {/* ================================================= */}

                    <Typography
                        component={Link}
                        to="/"
                        sx={{
                            display: {
                                xs: "none",
                                md: "flex",
                            },

                            position: "absolute",
                            left: "50%",
                            top: "50%",
                            transform:
                                "translate(-50%, -50%)",

                            alignItems: "center",
                            justifyContent: "center",

                            textDecoration: "none",

                            fontFamily:
                                "'Poppins', sans-serif",

                            fontWeight: 900,

                            whiteSpace: "nowrap",

                            textAlign: "center",

                            zIndex: 3,

                            transition: ".3s",

                            "&:hover": {
                                transform:
                                    "translate(-50%, -50%) scale(1.04)",
                            },
                        }}
                    >

                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                lineHeight: 1,

                                position: "relative",
                            }}
                        >

                            {/* LOGO GLOW */}

                            <Box
                                sx={{
                                    position: "absolute",
                                    width: 120,
                                    height: 50,
                                    top: -5,
                                    borderRadius: "50%",
                                    background:
                                        "rgba(255,60,15,.08)",
                                    filter: "blur(18px)",
                                    zIndex: -1,
                                }}
                            />

                            <Typography
                                sx={{
                                    fontSize: {
                                        md: 22,
                                        lg: 25,
                                    },

                                    fontWeight: 900,

                                    letterSpacing: 1,

                                    background:
                                        "linear-gradient(180deg,#fff0e4 0%,#ff7135 48%,#b52a0d 100%)",

                                    WebkitBackgroundClip:
                                        "text",

                                    WebkitTextFillColor:
                                        "transparent",

                                    textShadow:
                                        "0 0 20px rgba(255,70,15,.20)",
                                }}
                            >
                                VexConquer
                            </Typography>

                            <Typography
                                sx={{
                                    mt: .4,

                                    fontSize: {
                                        md: 11,
                                        lg: 12,
                                    },

                                    fontWeight: 900,

                                    letterSpacing: 4,

                                    color: "#e8d9d2",
                                }}
                            >
                                CLASSIC 5165
                            </Typography>

                        </Box>

                    </Typography>


                    {/* ================================================= */}
                    {/* MOBILE MENU */}
                    {/* ================================================= */}

                    <Box
                        sx={{
                            flexGrow: 1,
                            display: {
                                xs: "flex",
                                md: "none",
                            },
                        }}
                    >

                        <IconButton
                            size="large"
                            onClick={handleOpenNavMenu}
                            sx={{
                                color: "#ff6935",

                                border:
                                    "1px solid rgba(255,70,15,.30)",

                                borderRadius: "6px",

                                background:
                                    "rgba(255,70,15,.04)",

                                boxShadow:
                                    "0 0 15px rgba(255,70,15,.05)",

                                "&:hover": {
                                    background:
                                        "rgba(255,70,15,.12)",

                                    borderColor:
                                        "#ff6130",

                                    boxShadow:
                                        "0 0 20px rgba(255,70,15,.15)",
                                },
                            }}
                        >
                            <MenuIcon />
                        </IconButton>


                        <Menu
                            anchorEl={anchorElNav}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}

                            PaperProps={{
                                sx: {
                                    borderRadius: "8px",
                                    mt: 1.5,
                                    minWidth: 260,

                                    background:
                                        "linear-gradient(145deg,#160c09,#080707)",

                                    border:
                                        "1px solid rgba(255,70,15,.25)",

                                    boxShadow:
                                        "0 25px 60px rgba(0,0,0,.75)",

                                    overflow: "hidden",

                                    "&:before": {
                                        content: '""',
                                        display: "block",
                                        height: "2px",
                                        background:
                                            "linear-gradient(90deg,transparent,#a8270d,#ff5420,#ff9a4d,#ff5420,#a8270d,transparent)",
                                    },
                                },
                            }}
                        >

                            <MenuItem
                                component={Link}
                                to="/"
                                onClick={handleCloseNavMenu}
                                sx={dropdownItemStyle}
                            >
                                ⚔ HOME
                            </MenuItem>

                            <MenuItem
                                component={Link}
                                to="/downloads"
                                onClick={handleCloseNavMenu}
                                sx={dropdownItemStyle}
                            >
                                ↓ DOWNLOAD
                            </MenuItem>

                            <MenuItem
                                onClick={(e) =>
                                    setAnchorElAbout(e.currentTarget)
                                }
                                sx={dropdownItemStyle}
                            >
                                🔥 ABOUT GAME
                            </MenuItem>


                            <Menu
                                anchorEl={anchorElAbout}
                                open={Boolean(anchorElAbout)}
                                onClose={() =>
                                    setAnchorElAbout(null)
                                }

                                PaperProps={{
                                    sx: {
                                        background:
                                            "linear-gradient(145deg,#160c09,#080707)",

                                        border:
                                            "1px solid rgba(255,70,15,.25)",

                                        boxShadow:
                                            "0 20px 50px rgba(0,0,0,.7)",

                                        "&:before": {
                                            content: '""',
                                            display: "block",
                                            height: "2px",
                                            background:
                                                "linear-gradient(90deg,transparent,#ff5420,transparent)",
                                        },
                                    },
                                }}
                            >

                                <MenuItem
                                    component={Link}
                                    to="/ranks"
                                    sx={dropdownItemStyle}
                                >
                                    Rankings
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/marketplace"
                                    sx={dropdownItemStyle}
                                >
                                    Marketplace
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="https://discord.gg/GusbbTUdRQ"
                                    sx={dropdownItemStyle}
                                >
                                    Store
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/schedules"
                                    sx={dropdownItemStyle}
                                >
                                    Schedule
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/updates"
                                    sx={dropdownItemStyle}
                                >
                                    Updates
                                </MenuItem>

                            </Menu>

                        </Menu>

                    </Box>


                    {/* ================================================= */}
                    {/* MOBILE LOGO */}
                    {/* ================================================= */}

                    <Typography
                        component={Link}
                        to="/"
                        sx={{
                            display: {
                                xs: "flex",
                                md: "none",
                            },

                            flexGrow: 1,

                            justifyContent: "center",

                            textDecoration: "none",

                            fontFamily:
                                "'Poppins', sans-serif",

                            fontWeight: 900,

                            lineHeight: 1,

                            textShadow:
                                "0 0 18px rgba(255,70,15,.15)",
                        }}
                    >

                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >

                            <Typography
                                sx={{
                                    fontSize: 18,
                                    fontWeight: 900,

                                    background:
                                        "linear-gradient(180deg,#fff0e4,#ff7135,#b52a0d)",

                                    WebkitBackgroundClip:
                                        "text",

                                    WebkitTextFillColor:
                                        "transparent",
                                }}
                            >
                                Vex
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: 8,
                                    color: "#d8c9c3",
                                    letterSpacing: 3,
                                    mt: .3,
                                }}
                            >
                                CLASSIC 5165
                            </Typography>

                        </Box>

                    </Typography>


                    {/* ================================================= */}
                    {/* DESKTOP NAV */}
                    {/* ================================================= */}

                    <Box
                        sx={{
                            flexGrow: 1,

                            display: {
                                xs: "none",
                                md: "flex",
                            },

                            gap: .5,

                            alignItems: "center",

                            pr: 3,
                        }}
                    >

                        <Button
                            component={Link}
                            to="/"
                            sx={navButtonStyle}
                        >
                            Home
                        </Button>


                        <Button
                            component={Link}
                            to="/downloads"
                            sx={navButtonStyle}
                        >
                            Download
                        </Button>


                        <Button
                            onClick={(e) =>
                                setAnchorElAbout(
                                    anchorElAbout
                                        ? null
                                        : e.currentTarget
                                )
                            }
                            sx={navButtonStyle}
                        >
                            About Game

                            <ArrowDropDownIcon
                                sx={{
                                    color: "#ff6332",
                                    fontSize: 20,
                                    ml: .3,
                                }}
                            />
                        </Button>


                        {/* ================================================= */}
                        {/* DROPDOWN */}
                        {/* ================================================= */}

                        <Box
                            sx={{
                                display: anchorElAbout
                                    ? "flex"
                                    : "none",

                                position: "absolute",

                                top: "95%",

                                left: 0,

                                background:
                                    "linear-gradient(145deg,#160c09,#080707)",

                                borderRadius: "8px",

                                p: 3,

                                gap: 5,

                                minWidth: "590px",

                                border:
                                    "1px solid rgba(255,70,15,.25)",

                                boxShadow:
                                    "0 25px 70px rgba(0,0,0,.75)",

                                "&:before": {
                                    content: '""',
                                    position: "absolute",
                                    top: 0,
                                    left: 25,
                                    right: 25,
                                    height: "2px",
                                    background:
                                        "linear-gradient(90deg,transparent,#a8270d,#ff5420,#ff9a4d,#ff5420,#a8270d,transparent)",
                                    boxShadow:
                                        "0 0 15px rgba(255,70,15,.35)",
                                },
                            }}

                            onMouseLeave={() =>
                                setAnchorElAbout(null)
                            }
                        >

                            {/* ================================================= */}
                            {/* IN GAME */}
                            {/* ================================================= */}

                            <Box>

                                <Typography
                                    sx={{
                                        color: "#ff6130",
                                        fontSize: 10,
                                        fontWeight: 900,
                                        letterSpacing: 2,
                                        mb: 1,
                                        px: 1,
                                    }}
                                >
                                    ⚔ IN GAME
                                </Typography>

                                <MenuItem
                                    component={Link}
                                    to="/ranks"
                                    sx={dropdownItemStyle}
                                >
                                    Rankings
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/marketplace"
                                    sx={dropdownItemStyle}
                                >
                                    Marketplace
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="https://discord.gg/GusbbTUdRQ"
                                    sx={dropdownItemStyle}
                                >
                                    Store
                                </MenuItem>

                            </Box>


                            {/* ================================================= */}
                            {/* INFORMATION */}
                            {/* ================================================= */}

                            <Box>

                                <Typography
                                    sx={{
                                        color: "#ff6130",
                                        fontSize: 10,
                                        fontWeight: 900,
                                        letterSpacing: 2,
                                        mb: 1,
                                        px: 1,
                                    }}
                                >
                                    🔥 VEX INFO
                                </Typography>

                                <MenuItem
                                    component={Link}
                                    to="/downloads"
                                    sx={dropdownItemStyle}
                                >
                                    Download
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/schedules"
                                    sx={dropdownItemStyle}
                                >
                                    Schedule
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/updates"
                                    sx={dropdownItemStyle}
                                >
                                    Updates
                                </MenuItem>

                            </Box>


                            {/* ================================================= */}
                            {/* COMMUNITY */}
                            {/* ================================================= */}

                            <Box>

                                <Typography
                                    sx={{
                                        color: "#ff6130",
                                        fontSize: 10,
                                        fontWeight: 900,
                                        letterSpacing: 2,
                                        mb: 1,
                                        px: 1,
                                    }}
                                >
                                    🛡 COMMUNITY
                                </Typography>

                                <MenuItem
                                    component="a"
                                    href="https://discord.gg/GusbbTUdRQ"
                                    target="_blank"
                                    sx={dropdownItemStyle}
                                >
                                    Discord
                                </MenuItem>

                                <MenuItem
                                    component="a"
                                    href="https://www.facebook.com/profile.php?id=61594043924507"
                                    target="_blank"
                                    sx={dropdownItemStyle}
                                >
                                    Facebook
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/wiki"
                                    onClick={handleCloseNavMenu}
                                    sx={dropdownItemStyle}
                                >
                                    Wiki / Guides
                                </MenuItem>

                            </Box>

                        </Box>

                    </Box>


                    {/* ================================================= */}
                    {/* RIGHT SIDE */}
                    {/* ================================================= */}

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.2,
                        }}
                    >

                        {!isLoggedIn ? (
                            <>

                                {/* ================================================= */}
                                {/* LOGIN */}
                                {/* ================================================= */}

                                <Button
                                    component={Link}
                                    to="/user/login"
                                    sx={{
                                        color: "#ff7135",

                                        fontWeight: 800,

                                        fontFamily:
                                            "'Poppins', sans-serif",

                                        fontSize: {
                                            xs: 11,
                                            md: 12,
                                        },

                                        letterSpacing: 1,

                                        px: {
                                            xs: 1.5,
                                            md: 2,
                                        },

                                        py: 1,

                                        border:
                                            "1px solid rgba(255,70,15,.40)",

                                        borderRadius: "5px",

                                        background:
                                            "rgba(255,70,15,.035)",

                                        position: "relative",

                                        overflow: "hidden",

                                        transition: ".3s",

                                        "&:before": {
                                            content: '""',
                                            position: "absolute",
                                            left: 0,
                                            bottom: 0,
                                            width: "100%",
                                            height: "2px",
                                            background:
                                                "linear-gradient(90deg,#a8270d,#ff5420,#ff9a4d)",
                                            transform:
                                                "scaleX(0)",
                                            transformOrigin:
                                                "center",
                                            transition: ".3s",
                                        },

                                        "&:hover": {
                                            color: "#ff9a70",
                                            background:
                                                "rgba(255,70,15,.10)",
                                            borderColor:
                                                "#ff6130",

                                            transform:
                                                "translateY(-1px)",

                                            boxShadow:
                                                "0 5px 20px rgba(255,70,15,.12)",
                                        },

                                        "&:hover:before": {
                                            transform:
                                                "scaleX(1)",
                                        },
                                    }}
                                >
                                    ⚔ LOGIN
                                </Button>


                                {/* ================================================= */}
                                {/* REGISTER */}
                                {/* ================================================= */}

                                <Button
                                    component={Link}
                                    to="/user/register"

                                    sx={{
                                        background:
                                            "linear-gradient(135deg,#8e1d0b,#e33b13,#ff8b42)",

                                        color: "#fff",

                                        fontWeight: 900,

                                        fontFamily:
                                            "'Poppins', sans-serif",

                                        fontSize: {
                                            xs: 11,
                                            md: 12,
                                        },

                                        letterSpacing: 1,

                                        px: {
                                            xs: 2,
                                            md: 3,
                                        },

                                        py: 1.2,

                                        borderRadius: "5px",

                                        boxShadow:
                                            "0 6px 25px rgba(255,70,15,.20)",

                                        transition: ".3s",

                                        position: "relative",

                                        overflow: "hidden",

                                        "&:after": {
                                            content: '""',
                                            position: "absolute",
                                            top: 0,
                                            left: "-100%",
                                            width: "100%",
                                            height: "100%",
                                            background:
                                                "linear-gradient(90deg,transparent,rgba(255,255,255,.15),transparent)",
                                            transition: ".5s",
                                        },

                                        "&:hover": {
                                            background:
                                                "linear-gradient(135deg,#b52a0d,#ff5420,#ffae65)",

                                            transform:
                                                "translateY(-2px)",

                                            boxShadow:
                                                "0 10px 30px rgba(255,70,15,.38)",
                                        },

                                        "&:hover:after": {
                                            left: "100%",
                                        },
                                    }}
                                >
                                    JOIN VEX
                                </Button>

                            </>
                        ) : (
                            <>

                                    <Button
                                        component={Link}
                                        to="https://discord.gg/GusbbTUdRQ"
                                        sx={{
                                            color: "#ff7135",
                                            fontWeight: 700,
                                            fontSize: 13,

                                            "&:hover": {
                                                color: "#ff9a70",
                                            },
                                        }}
                                    >
                                        Store
                                    </Button>

                                <Button
                                    component={Link}
                                    to="/user/change-password"
                                    sx={{
                                        color: "#d8d0cc",
                                        fontWeight: 700,
                                        fontSize: 13,

                                        "&:hover": {
                                            color: "#ff7135",
                                        },
                                    }}
                                >
                                    Change Password
                                </Button>

                                <Button
                                    component={Link}
                                    to="/user/logout"
                                    sx={{
                                        color: "#d8d0cc",
                                        fontWeight: 700,
                                        fontSize: 13,

                                        "&:hover": {
                                            color: "#f05b4f",
                                        },
                                    }}
                                >
                                    Logout
                                </Button>

                            </>
                        )}

                    </Box>

                </Toolbar>

            </Container>

        </AppBar>
    );
}

export default ResponsiveAppBar;

